import { MessageCircle, Clock, CheckCircle, Package, AlertTriangle, DollarSign, Pill } from 'lucide-react';

const NotificationItem = ({ notification, dispatch, onClose }) => {
  const handleAction = () => {
    dispatch({ type: 'MARK_NOTIFICATION_READ', payload: notification.id });

    if (notification.type === 'erx' || notification.type === 'dispensed') {
      dispatch({ type: 'SET_ACTIVE_TAB', payload: 'dispensing' });
    } else if (notification.type === 'order') {
      dispatch({ type: 'SET_ACTIVE_TAB', payload: 'orders' });
    } else if (notification.type === 'stock') {
      dispatch({ type: 'SET_ACTIVE_TAB', payload: 'inventory' });
    } else if (notification.type === 'pbs' || notification.type === 'expiry') {
      dispatch({ type: 'SET_ACTIVE_TAB', payload: 'customers' });
    }

    onClose();
  };

  const getIcon = () => {
    switch (notification.type) {
      case 'erx': return <Pill className="h-5 w-5" />;
      case 'dispensed': return <CheckCircle className="h-5 w-5" />;
      case 'stock': return <AlertTriangle className="h-5 w-5" />;
      case 'pbs': return <DollarSign className="h-5 w-5" />;
      case 'expiry': return <Clock className="h-5 w-5" />;
      case 'order': return <Package className="h-5 w-5" />;
      default: return <MessageCircle className="h-5 w-5" />;
    }
  };

  const getColorClass = () => {
    switch (notification.type) {
      case 'erx': return 'bg-blue-100 text-blue-600';
      case 'dispensed': return 'bg-green-100 text-green-600';
      case 'stock': return 'bg-red-100 text-red-600';
      case 'pbs': return 'bg-purple-100 text-purple-600';
      case 'expiry': return 'bg-orange-100 text-orange-600';
      case 'order': return 'bg-indigo-100 text-indigo-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <div
      className={`p-3 border-b border-gray-100/50 cursor-pointer transition-all duration-200 hover:bg-white/60 ${
        !notification.read ? 'bg-brand-50/50' : ''
      }`}
      onClick={handleAction}
    >
      <div className="flex items-start">
        <div className={`rounded-xl p-2 mr-3 ${getColorClass()}`}>
          {getIcon()}
        </div>
        <div className="flex-1">
          <p className="font-medium text-sm">{notification.title}</p>
          <p className="text-xs text-gray-600 mt-1">{notification.message}</p>
          <div className="flex justify-between items-center mt-2">
            <span className="text-xs text-gray-500">{notification.time}</span>
            {notification.action && (
              <button className="text-xs text-brand-600 font-medium hover:text-brand-700 transition-colors">
                {notification.action}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
